import * as React from 'react';
import { Text } from 'wix-ui-tpa';
import { useTranslation } from 'react-i18next';
import { st, classes } from './CalendarsInfoPopover.st.css';
import { setOpacity } from '../../../utils/colorUtils';
import { DEMO_CALENDARS_IDS } from '../../../constants';
var CalendarsInfoPopoverRow = function (_a) {
    var calendar = _a.calendar;
    var t = useTranslation()[0];
    var opacity = 0.5; // values between 0 and 1.
    var calendarName = calendar.name.split(/@(?=[^@]*$)/)[0];
    if (DEMO_CALENDARS_IDS.includes(calendar.idCrypt)) {
        calendarName = t(calendarName);
    }
    return (React.createElement("div", { className: st(classes.CalendarRow) },
        React.createElement("div", { className: st(classes.ColorIndicator), style: {
                backgroundColor: setOpacity(opacity, calendar.color),
            } }),
        React.createElement(Text, { className: st(classes.CalendarTitle) }, calendarName)));
};
export default CalendarsInfoPopoverRow;
//# sourceMappingURL=CalendarsInfoPopoverRow.js.map